import React from "react";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";
import './inputsearch.component.css';

//ICONS
import FaSearch from 'react-icons/lib/fa/search';

const InputSearch = (props) => {
    return (
        <span>
            <input 
                className={props.className}
                placeholder={props.placeholder}
                onKeyPress={(e) => props.onKeyPress(e)}
                onChange={props.onSearchChange}
                onBlur={props.onSearchBlur}
                value={props.value}
            />
            <button className="btnSearch"><FaSearch/></button>
        </span>
    )
}

const InputSearchWithStyles = styled(InputSearch) `
    width: calc(400px - 39px);
    padding-top: 20px;
    padding-bottom: 20px;
    padding-right: 54px;
    padding-left: 15px;
    border-radius: 5px;
    border: 1px solid ${Colors.secondary};
    outline:none;
    font-size:13px;
    transition: all 0.2s ease;

    &:focus{
        border: 1px solid ${Colors.primary};
    }

    @media screen and (max-width: 830px) {
        width: calc(100% - 71px);
        padding-right: 54px;
    }
`
export default InputSearchWithStyles;


// WEBPACK FOOTER //
// ./src/components/inputsearch/inputsearch.component.js